module.exports = __webpack_public_path__ + "media/images/yellow-17ec0b62ec32a05563677415c8abca8a.png";